module.exports = __webpack_public_path__ + "img/uk.a0b9d3d6.png";